import WorkerApiService from "../../workerApiServices";

class FormaDePagamentoService extends WorkerApiService {

    constructor() {
        super('/api/formaDePagamento')
    }

    search(){
        return this.get("/search")
    }

    save(object){
        return this.post("/save", object)
    }

    edit(object){
        return this.put("/edit", object)
    }



}

export default FormaDePagamentoService